import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService implements OnDestroy {
  isMobileSubject: BehaviorSubject<boolean>;
  isMobile$: Observable<boolean>;

  private readonly mobileBreakpoint = 1200; // Mobile breakpoint

  constructor() {
    // Initialize with the current screen size
    const initialIsMobile = window.innerWidth <= this.mobileBreakpoint;

    this.isMobileSubject = new BehaviorSubject<boolean>(initialIsMobile);
    this.isMobile$ = this.isMobileSubject.asObservable();

    // Listen to window resize events and emit screen size updates
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(200), // Debounce to limit frequent events
        map(() => window.innerWidth <= this.mobileBreakpoint),
        startWith(initialIsMobile) // Start with the initial value
      )
      .subscribe((isMobile) => this.isMobileSubject.next(isMobile));
  }

  ngOnDestroy(): void {
    // Clean up the BehaviorSubject when service is destroyed
    this.isMobileSubject.complete();
  }
}
